// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"4552cb163ce60f595176","715":"b9e0cb50c8724a7e5676","935":"619277c65ddc162a3efd","962":"4305d9c3852952fa29e1"}[chunkId] + ".css";
};